import { getAccessLabel, isAppDevice } from '../utils/socketHelpers'
import styles from './Tag.module.css'

const Tag = ({ socket }) => {
  const isApp = isAppDevice(socket.device)
  const label = getAccessLabel(socket.accessType)

  const tagContent = [label, isApp ? ' 📱' : '', socket.customInfo || ''].join(
    ''
  )

  return (
    <div
      className={[styles.tag, styles[socket.accessType || 'teacher']].join(' ')}
    >
      {tagContent}
    </div>
  )
}

export default Tag
